document.addEventListener('DOMContentLoaded', function() {
  const styleSelector = document.getElementById('product-style-selector');
  if (styleSelector) {
    styleSelector.addEventListener('change', handleStyleChange);
  }

  const styleSelectorSticky = document.getElementById('product-style-selector-sticky');
  if (styleSelectorSticky) {  
    styleSelectorSticky.addEventListener('change', handleStyleChange);
  }

  const stickyForm = document.querySelector('hdt-sticky-btn-atc form');
  const mainFormId = stickyForm.getAttribute('id'); 
  if (mainFormId) {
    attachBuyNowListener(mainFormId);
  }

  setupVariantSync();

  async function handleStyleChange(event) {
    const selector = event.target;
    const selectedOption = selector.selectedOptions[0];
    const selectedProductId = selectedOption.value;
    const productHandle = selectedOption.dataset.productHandle;
    const productContainer = selector.closest('.shopify-section'); 
    
    if (!productContainer || !selectedProductId) return;

    const form = productContainer.querySelector('form.hdt-main-product-form');
    const sectionIdInput = form.querySelector('input[name="section-id"]');
    const sectionId = sectionIdInput.value;
    

    const productJsonScript = document.querySelector(`script[data-prod-json-${selectedProductId}]`);
    if (!productJsonScript) return;

    try {
      const productData = JSON.parse(productJsonScript.textContent);
      const newFormId = `product-form-${sectionId}${productData.id}`; 

      updateBrowserUrl(productData, productHandle);
      updateProductGallery(productData, productContainer);

      reinitializeFormComponent(productData, productContainer, newFormId);
      reinitializeVariantPicker(productData, productContainer, newFormId);

      updateOptionSelectors(productData, productContainer, newFormId);

      updateStickyBar(productData, productContainer, selectedProductId, newFormId);

      setupVariantSync();

      updateSelectedStyle()

      const newFormContainer = productContainer.querySelector('.hdt-product-form');
      if (newFormContainer) {
        const firstVariant = productData.selected_or_first_available_variant;
        const targetVariantInput = newFormContainer.querySelector(`input[type="radio"][value="${firstVariant.option2}"]`);
        if (targetVariantInput) {
          targetVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

    } catch (e) {
      // console.error(`Error al procesar el cambio de estilo: `, e);
    }
  }

  function updateSelectedStyle() {
    const styleSelector = document.getElementById('product-style-selector');
    const styleInfo = document.getElementById('selected-style-info');

    // Obtenemos la opción que está seleccionada actualmente
    const selectedOption = styleSelector.options[styleSelector.selectedIndex];
    // Obtenemos el texto de esa opción y usamos .trim() para quitar espacios en blanco
    const selectedText = selectedOption.textContent.trim();
    // Actualizamos el contenido del párrafo
    styleInfo.textContent = 'Selected: ' + selectedText;
  }
  /**
   *  Actualiza la URL del navegador y el título de la página.
   */
  function updateBrowserUrl(productData) {
    const firstVariant = productData.selected_or_first_available_variant;
    const productHandle = productData.handle

    const newUrl = new URL(window.location.href);
    newUrl.pathname = `/products/${productHandle}`;
    newUrl.searchParams.set('variant', firstVariant.id); 

    const newTitle = firstVariant.name || productData.title || document.title; 
    document.title = newTitle;

    window.history.pushState({ productId: productData.id }, newTitle, newUrl.href);
  }
  /**
   * Actualiza la galería de imágenes del producto (principales y miniaturas)
   * usando el objeto de datos de un producto.
   * @param {object} productData - El objeto de producto parseado desde el JSON.
   */
  function updateProductGallery(productData) {
    const newMedia = productData.media;
    if (!newMedia) {
      // console.error("El objeto de producto no contiene un array 'media'.");
      return;
    }

    const mainImageSlides = document.querySelectorAll('.hdt-product-media__main .hdt-slider__slide');
    const thumbImageSlides = document.querySelectorAll('.hdt-product-media__thumb .hdt-slider__slide');

    const mainImageWidths = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946, 2189];
    const thumbImageWidths = [100, 200, 300];

    const updateSlideSet = (slides, widths, defaultWidth) => {
      slides.forEach((slide, index) => {
        const imgElement = slide.querySelector('img');
        if (!imgElement) return;

        if (newMedia[index]) {
          const mediaItem = newMedia[index];
          
          // Actualizamos los atributos de la imagen
          imgElement.src = `${mediaItem.src.split('?')[0]}?${mediaItem.src.split('?')[1]}&width=${defaultWidth}`;
          imgElement.srcset = generateSrcset(mediaItem.src, widths);
          imgElement.alt = mediaItem.alt || ''; // Actualizar el alt text
          imgElement.width = mediaItem.width;   // Actualizar dimensiones
          imgElement.height = mediaItem.height;

          // Es crucial actualizar el data-media-id para que el slider y el zoom funcionen
          slide.dataset.mediaId = mediaItem.id;
          
          // Actualizamos el aspect-ratio para evitar saltos de layout al cambiar
          const ratioDiv = slide.querySelector('.hdt-ratio');
          if (ratioDiv && mediaItem.aspect_ratio) {
              ratioDiv.style.setProperty('--aspect-ratioapt', mediaItem.aspect_ratio);
          }

          // Aseguramos que el slide sea visible
          slide.removeAttribute('hidden');
          slide.style.display = '';

        } else {
          // Si el nuevo producto tiene menos imágenes, ocultamos los slides sobrantes
          slide.setAttribute('hidden', true);
          slide.style.display = 'none';
        }
      });
    };
    
    updateSlideSet(mainImageSlides, mainImageWidths, 1060);
    updateSlideSet(thumbImageSlides, thumbImageWidths, 300);

    const mainSlider = document.querySelector('hdt-slider.hdt-slider-parent');
    const thumbSlider = document.querySelector('hdt-slider-thumb');
    
    if (mainSlider && typeof mainSlider.api?.update === 'function') {
        mainSlider.api.update();
        if (thumbSlider && typeof thumbSlider.api?.update === 'function') {
          thumbSlider.api.update();
        }
        // Volver al primer slide del nuevo set de imágenes
        mainSlider.api.select(0, false, true); 
    } else {
      // console.warn("No se pudo encontrar la API del slider para actualizar. La galería puede no funcionar correctamente después del cambio.");
    }
    
  }

  function reinitializeFormComponent(productData, productContainer, newFormId) {
    const form = productContainer.querySelector('form.hdt-main-product-form');
    if (!form) {
      // console.error("No se encontró el formulario principal del producto.");
      return;
    }

    form.id = newFormId;

    const firstVariant = productData.selected_or_first_available_variant;

    const productIdInput = form.querySelector('input[name="product-id"]');
    if (productIdInput) productIdInput.value = productData.id;

    const variantIdInput = form.querySelector('input[name="id"]');
    if (variantIdInput) variantIdInput.value = firstVariant.id;

    form.querySelectorAll('[form]').forEach(el => {
      el.setAttribute('form', newFormId);
    });

    const titleElement = document.querySelector('h1');
    if (titleElement) {
      titleElement.textContent = productData.title;
    }

    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
      const newBtnId = `btn-${newFormId}`;
      submitButton.id = newBtnId;
    }

    const variantPicker = document.querySelector('hdt-variant-picker');
    if (variantPicker) {
      variantPicker.setAttribute('update-url', firstVariant.id);
      variantPicker.setAttribute('form', newFormId);
      variantPicker.querySelectorAll('fieldset [form]').forEach(el => el.setAttribute('form', newFormId));
    }

    const comparePrice = document.querySelector('hdt-compare-at-price');
    if (comparePrice) {
      comparePrice.setAttribute('form', newFormId);
    }

    const price = document.querySelector('hdt-price');
    if (price) {
      price.setAttribute('form', newFormId);
      const priceElement = price.querySelector('.hdt-money')
      const priceFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(firstVariant.price / 100) 
      priceElement.textContent = priceFormat
    }

    const unitPrice = document.querySelector('hdt-unit-price');
    if (unitPrice) {
      unitPrice.setAttribute('form', newFormId);
    }

    const badge = document.querySelector('hdt-badge');
    if (badge) {
      badge.setAttribute('form', newFormId);
    }

    const productMedia = document.querySelector('hdt-product-media');
    if (productMedia) {
      productMedia.setAttribute('form', newFormId);
    }

    const quantityWrapper = document.querySelector('hdt-quantity-wrapp');
    if (quantityWrapper) {
      quantityWrapper.querySelectorAll('input[form]').forEach(input => {
        input.setAttribute('form', newFormId);
      });
    }

    const newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form); 
  }

  function reinitializeVariantPicker(productData, productContainer, newFormId) {
    const pickerContainer = productContainer.querySelector('.hdt-product__variant-picker');
    if (!pickerContainer) {
      // console.error("No se encontró el contenedor .hdt-product__variant-picker");
      return;
    }

    const styleContainer = pickerContainer.querySelector('.product-style');
    if (styleContainer) {
      styleContainer.remove(); 
    }

    const variantPicker = pickerContainer.querySelector('hdt-variant-picker');
    if (!variantPicker) {
      // console.error("No se encontró hdt-variant-picker.");
      return;
    }
    
    const variantsJsonScript = variantPicker.querySelector('[data-variants-json]');
    if (variantsJsonScript) {
      variantsJsonScript.textContent = JSON.stringify(productData.variants);
    } else {
      // console.error("No se encontró el script [data-variants-json] dentro del picker.");
      return;
    }

    try {
      const containerNoscript = pickerContainer.querySelector('.container-nojs');
      const oldNoscript = containerNoscript.querySelector('noscript');
      const parsedHTML = convertNoscriptToHTML(oldNoscript);
      const textContent = oldNoscript.innerHTML
      const newNoscript = document.createElement('noscript');
      newNoscript.className = parsedHTML.className;

      const noscriptInnerHtml = `
        <div class="hdt-product-form__input">
          <label class="hdt-form__label" for="${parsedHTML.querySelector('select').id}">Product variants</label>
          <div class="hdt-form__wrapp">
            <select name="id" id="${parsedHTML.querySelector('select').id}" class="${parsedHTML.querySelector('select').className}" form="${newFormId}">
              ${productData.variants.map(variant => {
                const inventoryQuantity = variant.available ? 1 : 0; // Valor por defecto seguro
                const inventoryPolicy = 'deny'; // Valor por defecto seguro
                return `
                <option 
                  value="${variant.id}" 
                  ${variant.id === productData.selected_or_first_available_variant.id ? 'selected="selected"' : ''}
                  data-mdid="${''}"
                  data-inventoryquantity="${inventoryQuantity}"
                  data-inventorypolicy="${inventoryPolicy}"
                  data-available="${variant.available}"
                >
                  ${variant.title} - ${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(variant.price / 100)}
                </option>
              `}).join('')}
            </select>
          </div>
        </div>
      `;

      newNoscript.innerHTML = noscriptInnerHtml;
      containerNoscript.parentNode.replaceChild(newNoscript, containerNoscript);

    } catch (error) {
      // console.log(error)
    }
    
    const newPickerContainer = pickerContainer.cloneNode(true);
    pickerContainer.parentNode.replaceChild(newPickerContainer, pickerContainer);

    if (styleContainer) {
      // `newPickerContainer` es el elemento que ahora está en el DOM.
      // Lo buscamos de nuevo para asegurar que tenemos la referencia correcta.
      const finalPickerContainer = productContainer.querySelector('.hdt-product__variant-picker');
      if (finalPickerContainer) {
        // Buscamos el hdt-variant-picker DENTRO del nuevo contenedor
        const finalVariantPicker = finalPickerContainer.querySelector('hdt-variant-picker');
        if (finalVariantPicker) {
          // Lo reinsertamos DENTRO del nuevo hdt-variant-picker.
          finalVariantPicker.appendChild(styleContainer);
        }
      }
    }
  }

  function updateOptionSelectors(productData, productContainer) {
    const form = document.querySelector('hdt-variant-picker');
    if (!form) return;

    const firstVariant = productData.selected_or_first_available_variant;

    rebuildSizePopover(productData, productContainer, firstVariant)

    const colorFieldset = form.querySelector('fieldset[data-index="1"]');
    if (colorFieldset) {
      const selectedColor = firstVariant.option2;
      const colorInputs = colorFieldset.querySelectorAll('input[type="radio"]');
      let targetInput = null;

      colorInputs.forEach(input => {
        if (input.value === selectedColor) {
          input.checked = true;
          targetInput = input; // Guardamos la referencia al input que acabamos de marcar
        } else {
          input.checked = false;
        }
      });
      
      const displaySpan = colorFieldset.querySelector('span[update-value]');
      if (displaySpan) {
        displaySpan.textContent = selectedColor;
      }
      
      if (targetInput) {
        targetInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        // Este caso solo debería ocurrir si el nuevo producto tiene un color que no existe en el DOM actual.
        // En ese escenario, la reconstrucción sería necesaria, pero es menos común.
        // Por ahora, solo advertimos en la consola.
        console.warn(`No se encontró un input de color para el valor: ${selectedColor}. El selector de color puede no estar sincronizado.`);
      }
    }
  }
  
  function updateStickyBar(productData, productContainer, selectedProductId, newFormId) {
    const mainSelector = document.getElementById('product-style-selector');
    if (mainSelector) {
      mainSelector.value = selectedProductId;
    }

    const stickyBar = document.querySelector('hdt-sticky-btn-atc');
    stickyBar.setAttribute('form', newFormId)

    const oldForm = stickyBar.querySelector('form');
    if (!oldForm) {
      // console.error("No se encontró el formulario dentro del sticky bar.");
      return;
    }

    const styleContainer = oldForm.querySelector('.product-style-sticky');
    if (styleContainer) {
      styleContainer.remove();
      const stickySelector = styleContainer.querySelector('select');
      if (stickySelector) stickySelector.value = selectedProductId;
    }

    const firstVariant = productData.selected_or_first_available_variant;
    const newFormStickyId = `form-product-sticky${productData.id}`;

    oldForm.id = newFormStickyId;

    const titleElement = stickyBar.querySelector('.hdt-sticky-atc__product h3');
    if (titleElement) {
      titleElement.textContent = productData.title;
    }

    const priceElement = stickyBar.querySelector('.hdt-sticky-atc__product-monney');
    if (priceElement) {
      priceElement.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(firstVariant.price / 100) 
    }

    const productIdInput = oldForm.querySelector('input[name="product-id"]'); 
    if (productIdInput) productIdInput.value = productData.id;

    const variantIdInput = oldForm.querySelector('input[name="id"]');
    if (variantIdInput) variantIdInput.value = firstVariant.id;

    oldForm.querySelectorAll('[form]').forEach(el => el.setAttribute('form', newFormStickyId));

    const variantPicker = oldForm.querySelector('hdt-variant-picker');
    if (variantPicker) {
      variantPicker.setAttribute('update-url', firstVariant.id);
    }

    const variantSelect = oldForm.querySelector('select[tag-select]');
    if (variantSelect) {
      variantSelect.innerHTML = ''; // Limpiar opciones antiguas
      productData.variants.forEach(variant => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.dataset.mdid = '';
        if (variant.id === firstVariant.id) {
          option.setAttribute('selected', 'selected');
        }
        const price = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(variant.price / 100);
        option.textContent = `${variant.title} - ${price}`;
        variantSelect.appendChild(option);
      });
    }
    
    const buyNowButton = oldForm.querySelector('button.hdt-product-form__buy-now');
    if (buyNowButton) {
      buyNowButton.id = `buy-now-form-product-sticky${productData.id}`;
    }

    const addToCartButton = oldForm.querySelector('button.hdt-sticky-atc__submit');
    if (addToCartButton) {
      addToCartButton.id = `btn-form-product-sticky${productData.id}`;
    }

    const newStickyBar = stickyBar.cloneNode(true);
    stickyBar.parentNode.replaceChild(newStickyBar, stickyBar);

    if (styleContainer) {
      const finalPickerContainer = productContainer.querySelector('.hdt-sticky-atc__product');
      if (finalPickerContainer) {
        const finalVariantPicker = finalPickerContainer.querySelector('hdt-variant-sticky');
        if (finalVariantPicker) {
          finalVariantPicker.appendChild(styleContainer);
        }
      }
    }

    updateOptionSelectorsStickyPicker(productData, firstVariant);

    const newStickyPicker = stickyBar.querySelector('hdt-variant-sticky');
    if (newStickyPicker) {
      const firstVariant = productData.variants.find(v => v.available) || productData.variants[0];
      const targetColorInput = newStickyPicker.querySelector(`input[type="radio"][name="Color"][value="${firstVariant.option2}"]`);
      if (targetColorInput) {
        targetColorInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
  /**
   * Reconstruye el picker del sticky bar, preservando el selector de estilos.
   */
  function updateOptionSelectorsStickyPicker(productData, firstVariant) {
    const variantPicker = document.querySelector('hdt-variant-sticky');
    if (!variantPicker) return;

    // --- Actualizar Selector de Talla (data-index="0") ---
    rebuildSizePopover(productData, variantPicker, firstVariant)

    // --- Actualizar Selector de Color (data-index="1") ---
    const colorFieldset = variantPicker.querySelector('fieldset[data-index="1"]');
    if (colorFieldset) {
      const selectedColor = firstVariant.option2;
      const colorInputs = colorFieldset.querySelectorAll('input[type="radio"]');
      let targetInput = null;

      colorInputs.forEach(input => {
        if (input.value === selectedColor) {
          input.checked = true;
          targetInput = input;
        } else {
          input.checked = false;
        }
      });
      
      const displaySpan = colorFieldset.querySelector('span[update-value]');
      if (displaySpan) {
        displaySpan.textContent = selectedColor;
      }
      
      if (targetInput) {
        targetInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        // Este caso solo debería ocurrir si el nuevo producto tiene un color que no existe en el DOM actual.
        // En ese escenario, la reconstrucción sería necesaria, pero es menos común.
        // Por ahora, solo advertimos en la consola.
        // console.warn(`No se encontró un input de color para el valor: ${selectedColor}. El selector de color puede no estar sincronizado.`);
      }

      if (typeof variantPicker.updateAvailability === 'function') {
        variantPicker.updateAvailability();
      } else {
        // console.warn('El componente hdt-variant-sticky no tiene un método público updateAvailability. La disponibilidad puede no ser correcta.');
      }
    }
  }

  function convertNoscriptToHTML(noscriptElement) {
    const textContent = noscriptElement.innerHTML || noscriptElement.textContent;
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = textContent;
    
    return tempContainer;
  }
  function rebuildSizePopover(productData, productContainer, firstVariant) {
    const oldPopover = productContainer.querySelector('hdt-popover.hdt-popover-variant');
    if (!oldPopover) {
      // console.error("No se encontró el popover de tallas para reconstruir.");
      return;
    }

    const newPopover = document.createElement('hdt-popover');
    for (const attr of oldPopover.attributes) {
      newPopover.setAttribute(attr.name, attr.value);
    }
    
    const oldRichlist = oldPopover.querySelector('hdt-richlist');
    const newRichlist = document.createElement('hdt-richlist');
    if(oldRichlist) {
      for (const attr of oldRichlist.attributes) {
        newRichlist.setAttribute(attr.name, attr.value);
      }
    }
    
    const allSizes = [...new Set(productData.variants.map(v => v.option1))];
    const selectedSize = firstVariant.option1;

    allSizes.forEach(size => {
      const button = document.createElement('button');
      button.type = 'button';
      button.role = 'option';
      button.value = size;
      button.textContent = size;
      button.setAttribute('aria-selected', size === selectedSize ? 'true' : 'false');
      newRichlist.appendChild(button);
    });
    newRichlist.setAttribute('selected', selectedSize);

    newPopover.appendChild(newRichlist);
    oldPopover.parentNode.replaceChild(newPopover, oldPopover);
    
    const sizeFieldset = productContainer.querySelector('fieldset[data-index="0"]');
    if (sizeFieldset) {

      const hiddenInput = sizeFieldset.querySelector('input[name="option1"]');
      hiddenInput.value = selectedSize;

      const openButton = sizeFieldset.querySelector('button.hdt-select');
      if (openButton) {
        openButton.setAttribute('aria-controls', newPopover.id);
      }
    }

  }
  /**
   * Genera un string para el atributo srcset basado en una URL base y un array de anchos.
   * @param {string} baseUrl - La URL de la imagen sin parámetros de tamaño.
   * @param {number[]} widths - Un array de anchos para generar el srcset.
   * @returns {string} - El string completo para el atributo srcset.
   */
  function generateSrcset(baseUrl, widths) {
    if (!baseUrl) return '';
    const cleanUrl = baseUrl.split('?')[0];
    const version = baseUrl.split('?')[1] || '';

    return widths
      .map(width => `${cleanUrl}?${version}&width=${width} ${width}w`)
      .join(', ');
  }
  function colorInteraction(event) { 
    const clickedElement = event.target;
    const fieldset = clickedElement.closest('fieldset');
    if (!fieldset) return;

    const optionIndex = fieldset.dataset.index;
    let newValue = null;

    if (clickedElement.closest('.hdt-product-form__values')) {
      const radio = clickedElement.closest('label')?.previousElementSibling;
      if (radio && radio.type === 'radio') {
        newValue = radio.value;
      }
    } 
    
    if (newValue === null) return;

    const target = document.querySelector('hdt-variant-picker');
    const targetFieldset = target.querySelector(`fieldset[data-index="${optionIndex}"]`);
    if (targetFieldset) {
      const targetRadio = targetFieldset.querySelector(`input[type="radio"][value="${newValue}"]`);
      if (targetRadio && !targetRadio.checked) {
        targetRadio.click();
      }
    }
  }
  function sizeInteraction(event) { 
    const newValue = event.detail.value; 

    if (!newValue) return;

    const target = document.querySelector('hdt-variant-picker');
    const targetFieldset = target.querySelector('fieldset[data-index="0"]');
    if (targetFieldset) {
      const richlist = targetFieldset.querySelector('hdt-richlist');
      if (richlist && richlist.getAttribute('selected') !== newValue) {
        const targetButton = richlist.querySelector(`button[role="option"][value="${newValue}"]`);
        if (targetButton) {
          targetButton.click();
        }
      }
    }
  }

  function setupVariantSync() {
    const mainPicker = document.querySelector('hdt-variant-picker');
    const mainSticky = document.querySelector('hdt-sticky-btn-atc');

    if (!mainPicker || !mainSticky) {
      // console.log("No se encontraron ambos contenedores de variantes para la sincronización.");
      return;
    }

    const syncPicker = (source, target, sourceName, targetName) => {
      source.addEventListener('click', (event) => {
        const clickedElement = event.target;
        const fieldset = clickedElement.closest('fieldset');
        
        if (!fieldset) return;

        const optionIndex = fieldset.dataset.index;
        let newValue = null;

        if (clickedElement.closest('.hdt-product-form__values')) { 
          const radio = clickedElement.closest('label')?.previousElementSibling;
          if (radio && radio.type === 'radio') {
            newValue = radio.value;
          }
        } else if (clickedElement.matches('button[role="option"]')) {
          newValue = clickedElement.value;
        }

        if (newValue === null) return;

        const targetFieldset = target.querySelector(`fieldset[data-index="${optionIndex}"]`);
        if (targetFieldset) {
          const targetRadio = targetFieldset.querySelector(`input[type="radio"][value="${newValue}"]`);
          if (targetRadio && !targetRadio.checked) {
            targetRadio.click();
          }

          const targetButton = targetFieldset.querySelector(`button[role="option"][value="${newValue}"]`);
          if (targetButton && targetButton.getAttribute('aria-selected') === 'false') {
            targetButton.click();
          }
        }
      });
    };

    syncPicker(mainPicker, mainSticky, 'Principal', 'Sticky');
    
    // Sincronización de eventos de color y talla desde sticky hacia principal
    mainSticky.addEventListener('click', colorInteraction, true);
    mainSticky.addEventListener('richlist:change', sizeInteraction, true);
    
    // ========== SINCRONIZACIÓN DE PICKER PRINCIPAL A STICKY ==========
    const syncMainToSticky = (newValue) => {
      if (!newValue) return;

      // console.log('[MAIN → STICKY] Sincronizando talla:', newValue);

      const stickyFieldset = mainSticky.querySelector('fieldset[data-index="0"]');
      if (stickyFieldset) {
        const richlist = stickyFieldset.querySelector('hdt-richlist');
        if (richlist && richlist.getAttribute('selected') !== newValue) {
          const targetButton = richlist.querySelector(`button[role="option"][value="${newValue}"]`);
          if (targetButton) {
            // console.log('[MAIN → STICKY] Actualizando sticky a:', newValue);
            targetButton.click();
          }
        }
      }
    };

    // Escuchar evento richlist:change en picker principal
    mainPicker.addEventListener('richlist:change', (event) => {
      const newValue = event.detail?.value;
      syncMainToSticky(newValue);
    }, true);
    
    // Escuchar clicks en TODOS los popovers del picker principal
    const mainSizeFieldset = mainPicker.querySelector('fieldset[data-index="0"]');
    if (mainSizeFieldset) {
      const allPopovers = mainSizeFieldset.querySelectorAll('hdt-popover');
      
      allPopovers.forEach((popover) => {
        // console.log('Configurando listener en popover principal:', popover.id);
        
        popover.addEventListener('click', (event) => {
          if (event.target.matches('button[role="option"]')) {
            const newValue = event.target.value;
            // console.log('[MAIN POPOVER] Click en talla:', newValue);
            
            setTimeout(() => {
              syncMainToSticky(newValue);
            }, 50);
          }
        }, true);
      });

      // Observer en el input hidden del picker principal
      const mainSizeInput = mainSizeFieldset.querySelector('input[name="option1"]');
      if (mainSizeInput) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
              const newValue = mainSizeInput.value;
              // console.log('[MAIN INPUT] MutationObserver detectó cambio:', newValue);
              syncMainToSticky(newValue);
            }
          });
        });

        observer.observe(mainSizeInput, { 
          attributes: true, 
          attributeFilter: ['value']
        });

        mainSizeInput.addEventListener('change', () => {
          const newValue = mainSizeInput.value;
          // console.log('[MAIN INPUT] Evento change:', newValue);
          syncMainToSticky(newValue);
        });

        mainSizeInput.addEventListener('input', () => {
          const newValue = mainSizeInput.value;
          // console.log('[MAIN INPUT] Evento input:', newValue);
          syncMainToSticky(newValue);
        });
      }

      // Observer en TODOS los hdt-richlist del picker principal
      const allRichlists = mainSizeFieldset.querySelectorAll('hdt-richlist');
      allRichlists.forEach((richlist) => {
        // console.log('Configurando listener en richlist principal:', richlist.id);
        
        const richlistObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'selected') {
              const newValue = richlist.getAttribute('selected');
              // console.log('[MAIN RICHLIST] Cambio en selected:', newValue);
              syncMainToSticky(newValue);
            }
          });
        });

        richlistObserver.observe(richlist, {
          attributes: true,
          attributeFilter: ['selected']
        });
      });
    }

    // ========== SINCRONIZACIÓN DE STICKY A PICKER PRINCIPAL ==========
    const syncStickyToMain = (newValue) => {
      if (!newValue) return;

      // console.log('[STICKY → MAIN] Sincronizando talla:', newValue);

      const mainFieldset = mainPicker.querySelector('fieldset[data-index="0"]');
      if (mainFieldset) {
        const richlist = mainFieldset.querySelector('hdt-richlist');
        if (richlist && richlist.getAttribute('selected') !== newValue) {
          const targetButton = richlist.querySelector(`button[role="option"][value="${newValue}"]`);
          if (targetButton) {
            // console.log('[STICKY → MAIN] Actualizando main a:', newValue);
            targetButton.click();
          }
        }
      }
    };

    // Escuchar clicks en TODOS los popovers del sticky
    const stickySizeFieldset = mainSticky.querySelector('fieldset[data-index="0"]');
    if (stickySizeFieldset) {
      const allStickyPopovers = stickySizeFieldset.querySelectorAll('hdt-popover');
      
      allStickyPopovers.forEach((popover) => {
        // console.log('Configurando listener en popover sticky:', popover.id);
        
        popover.addEventListener('click', (event) => {
          if (event.target.matches('button[role="option"]')) {
            const newValue = event.target.value;
            // console.log('[STICKY POPOVER] Click en talla:', newValue);
            
            setTimeout(() => {
              syncStickyToMain(newValue);
            }, 50);
          }
        }, true);
      });

      // Observer en el input hidden del sticky
      const stickySizeInput = stickySizeFieldset.querySelector('input[name="option1"]');
      if (stickySizeInput) {
        const stickyObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
              const newValue = stickySizeInput.value;
              // console.log('[STICKY INPUT] MutationObserver detectó cambio:', newValue);
              syncStickyToMain(newValue);
            }
          });
        });

        stickyObserver.observe(stickySizeInput, { 
          attributes: true, 
          attributeFilter: ['value']
        });

        stickySizeInput.addEventListener('change', () => {
          const newValue = stickySizeInput.value;
          // console.log('[STICKY INPUT] Evento change:', newValue);
          syncStickyToMain(newValue);
        });

        stickySizeInput.addEventListener('input', () => {
          const newValue = stickySizeInput.value;
          // console.log('[STICKY INPUT] Evento input:', newValue);
          syncStickyToMain(newValue);
        });
      }

      // Observer en TODOS los hdt-richlist del sticky
      const allStickyRichlists = stickySizeFieldset.querySelectorAll('hdt-richlist');
      allStickyRichlists.forEach((richlist) => {
        // console.log('Configurando listener en richlist sticky:', richlist.id);
        
        const stickyRichlistObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'selected') {
              const newValue = richlist.getAttribute('selected');
              // console.log('[STICKY RICHLIST] Cambio en selected:', newValue);
              syncStickyToMain(newValue);
            }
          });
        });

        stickyRichlistObserver.observe(richlist, {
          attributes: true,
          attributeFilter: ['selected']
        });
      });
    }
  }
  function attachBuyNowListener(formId) {
    const form = document.getElementById(formId);
    if (!form) {
      // console.log(`No se encontró el formulario con ID: ${formId} para vincular 'Buy Now'.`);
      return;
    }

    const buyNowButton = form.querySelector(`.hdt-product-form__buy-now`);
    const variantInput = form?.querySelector('input[name="id"]');
    const addToCartButton = form?.querySelector('button[name="add"]');

    if (!buyNowButton || !form || !variantInput || !addToCartButton) {
      // console.log("No se encontraron todos los elementos necesarios para vincular el 'Buy Now' en el form:", formId);
      return;
    }

    const cleanButton = buyNowButton.cloneNode(true);
    buyNowButton.parentNode.replaceChild(cleanButton, buyNowButton);

    cleanButton.addEventListener('click', function() {
      const variantValue = variantInput.value;
      if (variantValue) {
        window.location.href= `https://snatchedbodyus.myshopify.com/cart/${ variantValue }:1`;
      } else {
        // console.log("No se pudo encontrar el ID de la variante para el 'Buy Now'.");
      }
    });

    if (!form.dataset.buyNowListenerAttached) {
      form.addEventListener('change', function() {
        if (addToCartButton.disabled) {
          cleanButton.setAttribute('disabled', 'disabled');
        } else {
          cleanButton.removeAttribute('disabled');
        }
      });
      form.dataset.buyNowListenerAttached = 'true';
    }

    if (addToCartButton.disabled) {
      cleanButton.setAttribute('disabled', 'disabled');
    } else {
      cleanButton.removeAttribute('disabled');
    }
  }
});
